import React, { useState } from 'react';
import { useQuery } from 'react-query';
import api from '../services/api';
import { FiPlus, FiEdit, FiTrash2 } from 'react-icons/fi';
import { useForm } from 'react-hook-form';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';

const Cycles = () => {
  //const { user } = useAuth();
  const { data, isLoading, refetch } = useQuery('cycles', () => api.get('/cycles').then(res => res.data.data));
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  const openAdd = () => {
    setEditing(null);
    reset({ cycle: '', description: '' });
    setShowModal(true);
  };
  const openEdit = (cycle) => {
    setEditing(cycle);
    reset({ cycle: cycle.cycle, description: cycle.description });
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    setEditing(null);
    reset();
  };

  const onSubmit = async (form) => {
    try {
      if (editing) {
        await api.put(`/cycles/${editing.id}`, form);
      } else {
        await api.post('/cycles', form);
      }
      refetch();
      closeModal();
    } catch (e) {
      alert("Erreur lors de l'enregistrement du cycle");
    }
  };

  const handleDelete = async (id) => {
    const Swal = (await import('sweetalert2')).default;
    const result = await Swal.fire({
      title: 'Supprimer ce cycle ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler',
    });
    if (result.isConfirmed) {
      await api.delete(`/cycles/${id}`);
      refetch();
      Swal.fire('Supprimé !', 'Le cycle a été supprimé.', 'success');
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">Cycles</h1>
        <ConditionalButton
          entity="cycles"
          permission="create"
          onClick={openAdd}
          className="flex items-center space-x-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
        >
          <FiPlus /> <span>Nouveau cycle</span>
        </ConditionalButton>
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-center dark:text-gray-300">Chargement...</div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Nom</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Description</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
              {Array.isArray(data) && data.length === 0 ? (
                <tr><td colSpan="3" className="px-6 py-4 text-center text-gray-500 dark:text-gray-400">Aucun cycle</td></tr>
              ) : (
                (Array.isArray(data) ? data : []).map((cycle) => (
                  <tr key={cycle.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/80 transition-colors duration-150">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-200">{cycle.cycle}</td>
                    <td className="px-6 py-4 text-sm text-gray-500 dark:text-gray-300">{cycle.description}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right">
                      <ConditionalActions
                        entity="cycles"
                        onEdit={() => openEdit(cycle)}
                        onDelete={() => handleDelete(cycle.id)}
                        editIcon={FiEdit}
                        deleteIcon={FiTrash2}
                        className="flex space-x-2 justify-end"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
            <h2 className="text-xl font-semibold mb-4">{editing ? 'Modifier' : 'Ajouter un'} cycle</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
                <input type="text" {...register('cycle', { required: true })} className="block w-full rounded-lg border border-gray-300 px-3 py-2" />
                {errors.cycle && <span className="text-red-500 text-xs mt-1">Champ obligatoire</span>}
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <input type="text" {...register('description')} className="block w-full rounded-lg border border-gray-300 px-3 py-2" />
              </div>
              <div className="flex justify-end space-x-2 mt-6">
                <button type="button" className="px-4 py-2 bg-gray-200 dark:bg-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600" onClick={closeModal}>Annuler</button>
                <ConditionalButton
                  entity="cycles"
                  permission={editing ? "update" : "create"}
                  type="submit"
                  className="px-4 py-2 bg-primary-600 text-white rounded-lg"
                >
                  Enregistrer
                </ConditionalButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cycles;
